export class Cours {
    constructor(
        public id?: number,
        public candidatureFormationId?: number,
        public code?: string,
        public libelle?: string,
        public ects?: number ,
        public index?:number
    ) {
    }


}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/candidature/cours.model.ts